<template>
  <v-flex column wrap class="container">
    <text-field
      v-model="form.apply"
      :validator="vs.apply"
      label="Title"
    />
    <textarea-field
      v-model="form.titleDescription"
      :validator="vs.titleDescription"
      label="Description"
    />
    <v-checkbox
      v-model="form.required"
      label="Workshops are required"
    />
    <textarea-field
      v-if="form.required"
      v-model="form.snackbarText"
      :validator="vs.snackbarText"
      label="Snackbar validation text"
    />
  </v-flex>
</template>

<script>
export default {
  name: 'workshops-form',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        apply: 'Apply to workshops',
        titleDescription: 'Here you can register for attending one or more workshops at the event.',
        required: false,
        snackbarText: 'At least one workshop is required',
      },
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  mounted () {
    if(this.initialValues && Object.keys(this.initialValues).length) {
      this.form = {...this.form, ...this.initialValues}
    }
    this.$emit('values', this.form)
  },
}
</script>

<style scoped>
  .container {
    max-width: 435px;
    margin: 0px;
    padding-left: 0px;
    padding-right: 0px;
  }
</style>
